'use strict';

angular.module('theme').directive('rememberValue', function ($cookies, md5) {
	return {
		restrict: 'A',
		scope: {
			cookieName: '@rememberValue'
		},
		link: function (scope, $element) {
			var cookieValue = $cookies.get(scope.cookieName);
			if (cookieValue) {
				$element.val(cookieValue);
			}

			$element.on('blur', function () {
				//console.log('remember-value save', $element.val());
				localStorage.setItem('mkref', md5.createHash(($element.val())));
			});
		}
	};
});
